import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store  from './store';

// Global event listener to clear the input field if invalid characters are detected on blur
document.addEventListener('focusout', (e) => {
  if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
    const type = (e.target.type || '').toLowerCase();
    // Skip non-text input types that have their own format
    if (['password', 'date', 'time', 'datetime-local', 'number', 'color', 'range', 'file', 'hidden'].includes(type)) return;

    const isPassword = 
                       (e.target.name && e.target.name.toLowerCase().includes('password')) || 
                       (e.target.placeholder && e.target.placeholder.toLowerCase().includes('password'));
    if (isPassword) return;

    const isEmail = e.target.type === 'email' || (e.target.name && e.target.name.toLowerCase().includes('email'));
    const regex = isEmail ? /[^\p{L}\p{N}\s,._@-]/u : /[^\p{L}\p{N}\s,._-]/u;

    if (regex.test(e.target.value)) {
      // Clear the ENTIRE input value if any invalid characters are found
      const newValue = '';
      
      // Update the value bypassing React's synthetic event tracker
      const prototype = Object.getPrototypeOf(e.target);
      const nativeSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
      
      if (nativeSetter) {
        nativeSetter.call(e.target, newValue);
        e.target.dispatchEvent(new Event('input', { bubbles: true }));
      } else {
        e.target.value = newValue;
      }
    }
  }
});

// Global event listener to prevent typing invalid characters
document.addEventListener('keydown', (e) => {
  if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
    const type = (e.target.type || '').toLowerCase();
    if (['password', 'date', 'time', 'datetime-local', 'number', 'color', 'range', 'file', 'hidden'].includes(type)) return;

    const isPassword = 
                       (e.target.name && e.target.name.toLowerCase().includes('password')) || 
                       (e.target.placeholder && e.target.placeholder.toLowerCase().includes('password'));
    if (isPassword) return;

    if (e.key && e.key.length === 1) {
      const isEmail = e.target.type === 'email' || (e.target.name && e.target.name.toLowerCase().includes('email'));
      const regex = isEmail ? /[^\p{L}\p{N}\s,._@-]/u : /[^\p{L}\p{N}\s,._-]/u;

      if (regex.test(e.key)) {
        e.preventDefault();
      }
    }
  }
});

// Global event listener to prevent pasting invalid characters
document.addEventListener('paste', (e) => {
  if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
    const type = (e.target.type || '').toLowerCase();
    if (['password', 'date', 'time', 'datetime-local', 'number', 'color', 'range', 'file', 'hidden'].includes(type)) return;

    const isPassword = 
                       (e.target.name && e.target.name.toLowerCase().includes('password')) || 
                       (e.target.placeholder && e.target.placeholder.toLowerCase().includes('password'));
    if (isPassword) return;

    const pastedText = (e.clipboardData || window.clipboardData).getData('text');
    const isEmail = e.target.type === 'email' || (e.target.name && e.target.name.toLowerCase().includes('email'));
    const regex = isEmail ? /[^\p{L}\p{N}\s,._@-]/u : /[^\p{L}\p{N}\s,._-]/u;

    if (regex.test(pastedText)) {
      e.preventDefault();
    }
  }
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
